import props from "./../../../src-utils/propDefiner";

export default {
  ...props("fluid", { type: Boolean, default: undefined }, "pm-container"),
};
